import {AxiosResponse} from 'axios';
import {DateTime} from 'luxon';
import {all, call, put, select, takeLatest} from 'redux-saga/effects';

import {
  getProperties,
  getPropertiesFallback,
} from 'services/api/aem/properties-api';
import {isProduction} from 'services/api/api';
import {PropertiesActions} from 'store/properties';
import {Hotel, Properties} from 'store/properties/properties.interface';
import {propertiesLastQueryTimeSelector} from 'store/properties/properties.selectors';

export const CACHE_TTL_MINS = 30;

export function* getPropertiesData() {
  const lastQueryTime = yield select(propertiesLastQueryTimeSelector);
  const durationSinceLastQuery = DateTime.fromISO(lastQueryTime)
    ?.diffNow('minutes')
    .negate(); // Negate to get duration since now/local

  if (lastQueryTime && durationSinceLastQuery?.minutes < CACHE_TTL_MINS) {
    yield put(PropertiesActions.fetchCachedSuccess());
    return;
  }

  try {
    const response: AxiosResponse<Properties> = yield call(getProperties);
    yield put(PropertiesActions.fetchSuccess(response.data));
  } catch (err) {
    try {
      if (!isProduction) {
        throw 'No fallback in dev / staging';
      }
      const response: AxiosResponse<Properties> = yield call(
        getPropertiesFallback
      );
      yield put(PropertiesActions.fetchSuccess(response.data));
    } catch (errFallback) {
      yield put(
        PropertiesActions.fetchError({error: true, message: 'No results'})
      );
    }
  }
}

export function* propertySagas() {
  return yield all([takeLatest(PropertiesActions.fetch, getPropertiesData)]);
}
